.icon {
    display: flex;
    align-items: center;
    justify-content: center;
}

.animating {
    animation: searchBounce 1s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes searchBounce {
    0%,
    100% {
        transform: translate(0, 0);
    }

    40% {
        transform: translate(0, -2px);
    }

    70% {
        transform: translate(-2px, 0);
    }
}
